export default "__VITE_ASSET__ce62ebf0__"